import { render, staticRenderFns } from "./bdproduct2.vue?vue&type=template&id=4dfdb9f4&scoped=true"
import script from "./bdproduct2.vue?vue&type=script&lang=js"
export * from "./bdproduct2.vue?vue&type=script&lang=js"
import style0 from "./bdproduct2.vue?vue&type=style&index=0&id=4dfdb9f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfdb9f4",
  null
  
)

export default component.exports